module.exports = __webpack_public_path__ + "img/zhor2.62084d31.jpg";